"use strict";
var SidebarController = (function () {
    /* @ngInject */
    function SidebarController($routeParams, $location, API_URL, ORIGIN, userService, userSessionService, preferenceService) {
        var _this = this;
        this.$routeParams = $routeParams;
        this.$location = $location;
        this.userSessionService = userSessionService;
        this.preferenceService = preferenceService;
        this.districtManagedDefaultGroups = false;
        this.loadUser = function (currentUser) {
            _this.currentUser = currentUser;
        };
        this.apiUrl = API_URL;
        this.origin = ORIGIN;
        userService.get().then(this.loadUser);
    }
    SidebarController.prototype.isActivePath = function (path) {
        return "#" + this.$location.path() === path;
    };
    SidebarController.prototype.getPath = function (path) {
        return "#/" + this.$routeParams.tenantId + "/" + path;
    };
    SidebarController.prototype.getNtpDashboardPath = function () {
        return "" + this.origin + this.apiUrl.ntpDashboard;
    };
    SidebarController.prototype.showAssignStudyProgramsToGroups = function () {
        return this.currentUser && !this.userSessionService.isDistrictMode() &&
            this.currentUser.isAdmin();
    };
    SidebarController.prototype.showManageDefaultPrograms = function () {
        return this.currentUser && this.currentUser.isAdmin() &&
            this.userSessionService.isTenantManagingDefaults();
    };
    SidebarController.prototype.showSetupApPrograms = function () {
        if (!this.currentUser) {
            return false;
        }
        var subscriptionStudyPrograms = this.userSessionService.getSubscriptionStudyPrograms();
        if (!subscriptionStudyPrograms || !subscriptionStudyPrograms.apCount) {
            // No AP programs to setup
            return false;
        }
        if (this.currentUser.isDistrictAdmin() && this.userSessionService.isDistrictMode()) {
            return true;
        }
        return this.currentUser.isAdmin() && subscriptionStudyPrograms.isSchoolSubscription;
    };
    return SidebarController;
}());
exports.SidebarController = SidebarController;



/** WEBPACK FOOTER **
 ** ./app/sidebar/sidebar.controller.ts
 **/